let player;
let activeTrigger;
let playerRequestId = 0;

const PLAYER_ID = 'youtube-player';
const OPEN_CLASS = 'open';
const NO_SCROLL_CLASS = 'noscroll';
const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

const body = document.body;
const movieItems = document.querySelectorAll('.movie_item_inner');
const movieModal = document.querySelector('.movie_modal');
const movieModalClose = movieModal?.querySelector('.movie_modal_close');
const youtubePlayer = document.getElementById(PLAYER_ID);

/**
 * YouTube IFrame API 読み込み
 */
const loadYouTubeAPI = () =>
    new Promise(resolve => {
        if (window.YT?.Player) {
            resolve(window.YT);
            return;
        }

        const existingScript = document.querySelector(
            'script[src="https://www.youtube.com/iframe_api"]'
        );

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
        }

        window.onYouTubeIframeAPIReady = () => {
            resolve(window.YT);
        };
    });

/**
 * プレイヤー破棄
 */
const destroyPlayer = () => {
    if (!player) {
        return;
    }

    player.destroy();
    player = null;
};

/**
 * プレイヤー生成
 */
const createPlayer = async videoId => {
    const currentRequestId = ++playerRequestId;

    const YT = await loadYouTubeAPI();

    if (
        currentRequestId !== playerRequestId ||
        !movieModal?.classList.contains(OPEN_CLASS)
    ) {
        return;
    }

    destroyPlayer();

    player = new YT.Player(PLAYER_ID, {
        videoId,
        playerVars: {
            autoplay: 1,
            controls: 1,
            modestbranding: 1,
            rel: 0,
            playsinline: 1,
            origin: window.location.origin,
        },
        events: {
            onReady: event => {
                event.target.playVideo();
            },
        },
    });
};

/**
 * フォーカス可能要素取得
 */
const getFocusableElements = () =>
    Array.from(movieModal.querySelectorAll(FOCUSABLE_SELECTOR));

/**
 * モーダルを開く
 */
const openMovieModal = (videoId, trigger) => {
    if (!videoId || !body || !movieModal || !youtubePlayer) {
        return;
    }

    activeTrigger = trigger;

    movieModal.classList.add(OPEN_CLASS);
    body.classList.add(NO_SCROLL_CLASS);

    movieModalClose?.focus();

    createPlayer(videoId);
};

/**
 * モーダルを閉じる
 */
const closeMovieModal = () => {
    if (!movieModal?.classList.contains(OPEN_CLASS)) {
        return;
    }

    playerRequestId += 1;

    destroyPlayer();

    movieModal.classList.remove(OPEN_CLASS);
    body.classList.remove(NO_SCROLL_CLASS);

    if (activeTrigger) {
        activeTrigger.focus();
        activeTrigger = null;
    }
};

/**
 * 背景クリックで閉じる
 */
const handleModalClick = event => {
    if (!(event.target instanceof Element)) {
        return;
    }

    if (!event.target.closest('.youtube')) {
        closeMovieModal();
    }
};

/**
 * フォーカストラップ
 */
const keepFocusInModal = event => {
    if (
        !movieModal?.classList.contains(OPEN_CLASS) ||
        event.key !== 'Tab'
    ) {
        return;
    }

    const focusableElements = getFocusableElements();

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!firstElement || !lastElement) {
        event.preventDefault();
        movieModal.focus();
        return;
    }

    if (
        event.shiftKey &&
        document.activeElement === firstElement
    ) {
        event.preventDefault();
        lastElement.focus();
        return;
    }

    if (
        !event.shiftKey &&
        document.activeElement === lastElement
    ) {
        event.preventDefault();
        firstElement.focus();
    }
};

/**
 * イベント登録
 */
if (body && movieModal && movieItems.length > 0) {
    movieItems.forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();

            openMovieModal(
                item.dataset.videoId,
                item
            );
        });
    });

    movieModal.addEventListener('click', handleModalClick);

    movieModalClose?.addEventListener(
        'click',
        closeMovieModal
    );

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            closeMovieModal();
            return;
        }

        keepFocusInModal(event);
    });
}
